import { render, staticRenderFns } from "./SaveGroup.vue?vue&type=template&id=7dc580d3&scoped=true&"
import script from "./SaveGroup.vue?vue&type=script&lang=js&"
export * from "./SaveGroup.vue?vue&type=script&lang=js&"
import style0 from "./SaveGroup.vue?vue&type=style&index=0&id=7dc580d3&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc580d3",
  null
  
)

export default component.exports